module.exports = __webpack_public_path__ + "static/media/013a39bb-fcec-42d3-92e9-aabd3b898af9.a8816246.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/013a39bb-fcec-42d3-92e9-aabd3b898af9.jpg
// module id = 797
// module chunks = 0